import { render, staticRenderFns } from "./ExercisesSelectorStatisticsDialog.vue?vue&type=template&id=58720b1a&scoped=true"
import script from "./ExercisesSelectorStatisticsDialog.vue?vue&type=script&lang=js"
export * from "./ExercisesSelectorStatisticsDialog.vue?vue&type=script&lang=js"
import style0 from "./ExercisesSelectorStatisticsDialog.vue?vue&type=style&index=0&id=58720b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58720b1a",
  null
  
)

export default component.exports